const KT_HEADER_ANCHOR_SELECTOR = '[data-kilatech-converter-anchor]';

function mountKilatechDropdownInHeader() {
  const headerAnchor = document.querySelector(KT_HEADER_ANCHOR_SELECTOR);
  const kilatechWrapper = document.querySelector('.CC_KT_WRAPPER');

  if (!headerAnchor || !kilatechWrapper) return false;
  if (!headerAnchor.contains(kilatechWrapper)) {
    headerAnchor.appendChild(kilatechWrapper);
  }

  kilatechWrapper.setAttribute('data-embedded', 'true');
  kilatechWrapper.style.setProperty('position', 'static', 'important');
  kilatechWrapper.style.setProperty('top', 'auto', 'important');
  kilatechWrapper.style.setProperty('right', 'auto', 'important');
  kilatechWrapper.style.setProperty('left', 'auto', 'important');
  kilatechWrapper.style.setProperty('bottom', 'auto', 'important');
  sanitizeKilatechCurrencyLabels(kilatechWrapper);
  return true;
}

function sanitizeKilatechCurrencyLabels(scope) {
  if (!scope) return;

  scope.querySelectorAll('.currency_CC_KT').forEach((currencyLabel) => {
    const labelText = (currencyLabel.textContent || '').trim();
    const matchedIsoCode = labelText.match(/[A-Z]{3}/);
    if (matchedIsoCode) {
      currencyLabel.textContent = matchedIsoCode[0];
    }
  });
}

function ensureKilatechDropdownMount() {
  if (window.__ktHeaderMountTimer) return;

  let attempts = 0;
  window.__ktHeaderMountTimer = window.setInterval(() => {
    attempts += 1;
    const mounted = mountKilatechDropdownInHeader();
    if (mounted || attempts >= 40) {
      window.clearInterval(window.__ktHeaderMountTimer);
      window.__ktHeaderMountTimer = null;
    }
  }, 250);
}

if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.button.addEventListener('click', this.openSelector.bind(this));

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
        ensureKilatechDropdownMount();
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.classList.remove('overflow-hidden-mobile');
        document.querySelector('.menu-drawer').classList.remove('country-selector-open');
        this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden'),
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        this.syncKilatechCurrency(event.currentTarget);
        if (form) form.submit();
      }

      syncKilatechCurrency(selectedItem) {
        if (!this.elements.input || this.elements.input.name !== 'country_code') return;

        const selectedCountryCode = this.elements.input.value;
        if (!selectedCountryCode) return;

        const fallbackCountryCurrencyMap = {
          IN: 'INR',
          US: 'USD',
          GB: 'GBP',
        };

        const countryMapCurrency = window.KTCurrency?.countrycurrencymap?.[selectedCountryCode];
        const selectedItemCurrency = selectedItem
          ?.querySelector('.localization-form__currency')
          ?.textContent?.trim()
          ?.split(/\s+/)?.[0];
        const fallbackCurrency = fallbackCountryCurrencyMap[selectedCountryCode];
        const targetCurrency =
          countryMapCurrency || selectedItemCurrency || fallbackCurrency || window.localStorage?.getItem('currency');

        if (!targetCurrency) return;

        try {
          window.__ktPendingCurrency = targetCurrency;
          window.__ktPendingCountry = selectedCountryCode;

          if (window.KTCurrency?.lshandler) {
            window.KTCurrency.lshandler('currency', targetCurrency);
            window.KTCurrency.lshandler('country', selectedCountryCode);
          } else if (window.localStorage) {
            window.localStorage.setItem('currency', targetCurrency);
            window.localStorage.setItem('country', selectedCountryCode);
          }

          this.applyKilatechCurrency(targetCurrency);
          this.applyKilatechCurrencyWhenReady();
        } catch (error) {
          console.warn('KILATECH currency sync failed:', error);
        }
      }

      applyKilatechCurrency(targetCurrency) {
        if (!targetCurrency) return;
        if (!window.KTCurrency?.ready || typeof window.KTCurrency.convertAll !== 'function') return;

        const sourceCurrency = window.shopCurrency || window.Shopify?.currency?.active || 'INR';
        window.KTCurrency.convertAll(sourceCurrency, targetCurrency);
        window.KTCurrency.currentCurrency = targetCurrency;

        if (window.dropdown_CC_KT?.setValue) {
          window.dropdown_CC_KT.setValue(targetCurrency);
        }

        if (typeof window.dropdown_CC_KT?.latefixer === 'function') {
          window.dropdown_CC_KT.latefixer();
        }
      }

      applyKilatechCurrencyWhenReady() {
        let attempts = 0;
        const maxAttempts = 20;
        const timer = window.setInterval(() => {
          attempts += 1;
          mountKilatechDropdownInHeader();

          if (window.__ktPendingCurrency) {
            this.applyKilatechCurrency(window.__ktPendingCurrency);
          }

          if (window.KTCurrency?.ready || attempts >= maxAttempts) {
            window.clearInterval(timer);
          }
        }, 200);
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString(),
        );
        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute('data-prevent-hide')) {
          this.header.preventHide = true;
        }
        document.querySelector('.menu-drawer').classList.add('country-selector-open');
      }

      closeSelector(event) {
        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        this.elements.resetButton.classList.toggle('hidden', !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector('.country').textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries,
          );
        }

        this.querySelector('.country-selector').scrollTop = 0;
        this.querySelector('.country-selector__list').scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    },
  );
}
